import { render } from "./MenuIcon.vue?vue&type=template&id=48f91a9c"
import script from "./MenuIcon.vue?vue&type=script&lang=js"
export * from "./MenuIcon.vue?vue&type=script&lang=js"

import "./MenuIcon.vue?vue&type=style&index=0&id=48f91a9c&lang=scss"
script.render = render

export default script